import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ASZF: React.FC = () => {
  const contactDetails = [
    { icon: <FaPhone />, text: 'Nagy Péter Villanyszerelő mester', phone: '+36703620652' },
    { icon: <FaPhone />, text: 'Tamasi Krisztán villamosbiztonsági felülvizsgáló', phone: '+36706049889' },
    { icon: <FaEnvelope />, text: 'kelectrokft@gmail.com', link: 'mailto:kelectrokft@gmail.com' },
    { icon: <FaMapMarkerAlt />, text: 'SZOLNOK és 100km-es körzete' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-64 bg-gradient-to-r from-red-600 to-red-800">
        <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center items-center text-center text-white">
          <h1 className="text-4xl font-bold mb-4">
            Általános Szerződési Feltételek
          </h1>
          <p className="text-xl">
            K-Electro Kft. - Villanyszerelési és elektromos szolgáltatások
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          
          {/* 1. Általános rendelkezések */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              1. Általános rendelkezések
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>1.1.</strong> Jelen Általános Szerződési Feltételek (továbbiakban: ÁSZF) a K-Electro Kft. (továbbiakban: Szolgáltató) által nyújtott villanyszerelési és elektromos szolgáltatásokra vonatkoznak.</p>
              <p><strong>1.2.</strong> Szolgáltató adatai:</p>
              <ul className="ml-6 space-y-2">
                <li>• <strong>Cégnév:</strong> K-Electro Kft.</li>
                <li>• <strong>Cégjegyzékszám:</strong> 13-09-216399</li>
                <li>• <strong>Adószám:</strong> 27489394-2-13</li>
                <li>• <strong>Székhely:</strong> 2740 Abony, Mikes Kelemen utca 36</li>
                <li>• <strong>Villanyszerelő mester:</strong> Nagy Péter (+36703620652)</li>
                <li>• <strong>Villamosbiztonsági felülvizsgáló:</strong> Tamasi Krisztán (+36706049889)</li>
                <li>• <strong>Email:</strong> kelectrokft@gmail.com</li>
                <li>• <strong>Működési terület:</strong> Szolnok és 100 km-es körzete</li>
              </ul>
              <p><strong>1.3.</strong> Az ÁSZF minden megrendelésre és szolgáltatásnyújtásra vonatkozik, kivéve, ha a felek írásban másként állapodnak meg.</p>
            </div>
          </div>

          {/* 2. Szolgáltatások köre */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              2. Szolgáltatások köre
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>2.1.</strong> A Szolgáltató az alábbi tevékenységeket végzi:</p>
              <ul className="ml-6 space-y-2">
                <li>• Villanyszerelési munkák (új vezetékek, kapcsolók, aljzatok telepítése)</li>
                <li>• Napelem rendszerek telepítése és karbantartása</li>
                <li>• Klímaberendezések telepítése és szervize</li>
                <li>• Elektromos berendezések gyártása és fejlesztése</li>
                <li>• Villamos tervezési szolgáltatások</li>
                <li>• Rendezvények elektromos kiszolgálása</li>
                <li>• Villamosbiztonsági felülvizsgálatok</li>
                <li>• Hibaelhárítás és javítási munkák</li>
                <li>• Kamera és riasztórendszerek telepítése</li>
              </ul>
            </div>
          </div>

          {/* 3. Megrendelés és ajánlatkérés */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              3. Megrendelés és ajánlatkérés
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>3.1.</strong> Az ajánlatkérés telefonon, emailben vagy személyesen történhet.</p>
              <p><strong>3.2.</strong> A Szolgáltató ingyenes helyszíni felmérést biztosít a szolgáltatási területén.</p>
              <p><strong>3.3.</strong> Az árajánlat 30 napig érvényes, kivéve ha másként kerül megjelölésre.</p>
              <p><strong>3.4.</strong> A szerződés az árajánlat írásos vagy szóbeli elfogadásával jön létre.</p>
            </div>
          </div>

          {/* 4. Árak és fizetési feltételek */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              4. Árak és fizetési feltételek
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>4.1.</strong> Az árak az árajánlatban kerülnek meghatározásra, ÁFA-val együtt.</p>
              <p><strong>4.2.</strong> Fizetési módok:</p>
              <ul className="ml-6 space-y-2">
                <li>• Készpénz (munka befejezésekor)</li>
                <li>• Banki átutalás (számla kiállítása után 8 napon belül)</li>
                <li>• Bankkártyás fizetés (POS terminál)</li>
              </ul>
              <p><strong>4.3.</strong> Nagyobb értékű munkák esetén 50% előleg kérhető.</p>
              <p><strong>4.4.</strong> Késedelmes fizetés esetén a Szolgáltató jogosult késedelmi kamat felszámítására.</p>
            </div>
          </div>

          {/* 5. Teljesítés */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              5. Teljesítés és határidők
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>5.1.</strong> A teljesítési határidő az árajánlatban kerül meghatározásra.</p>
              <p><strong>5.2.</strong> A Szolgáltató vállalja a munkaterület takarítását a munka befejezése után.</p>
              <p><strong>5.3.</strong> Vis maior (elháríthatatlan külső ok) esetén a teljesítési határidő meghosszabbodik.</p>
              <p><strong>5.4.</strong> A Megrendelő köteles biztosítani a munkavégzéshez szükséges feltételeket (áram, víz, megközelíthetőség).</p>
            </div>
          </div>

          {/* 6. Garancia */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              6. Garancia és szavatosság
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>6.1.</strong> A Szolgáltató garanciát vállal a végzett munkára:</p>
              <ul className="ml-6 space-y-2">
                <li>• Villanyszerelési munkák: 2 év</li>
                <li>• Napelem rendszerek: 5 év (rendszerre), 25 év (panelek teljesítményére)</li>
                <li>• Klímaberendezések: gyártói garancia szerint</li>
                <li>• Egyedi berendezések: 1 év</li>
              </ul>
              <p><strong>6.2.</strong> A garancia nem terjed ki a nem rendeltetésszerű használatra és külső károkra.</p>
              <p><strong>6.3.</strong> Garanciajavítás során a Szolgáltató vállalja a hibás alkatrészek cseréjét.</p>
            </div>
          </div>

          {/* 7. Felelősség */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              7. Felelősség és biztosítás
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>7.1.</strong> A Szolgáltató felelősségbiztosítással rendelkezik.</p>
              <p><strong>7.2.</strong> A Szolgáltató köteles a hatályos biztonsági előírások betartására.</p>
              <p><strong>7.3.</strong> A munkavégzés során keletkezett károkért a Szolgáltató teljes felelősséget vállal.</p>
              <p><strong>7.4.</strong> A Megrendelő köteles előzetesen jelezni a rejtett vezetékeket és veszélyforrásokat.</p>
            </div>
          </div>

          {/* 8. Lemondás és módosítás */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              8. Lemondás és módosítás
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>8.1.</strong> A Megrendelő a munka megkezdése előtt 24 órával díjmentesen lemondhatja a megrendelést.</p>
              <p><strong>8.2.</strong> A munka megkezdése után lemondás esetén a már elvégzett munkák és beszerzett anyagok költségét meg kell téríteni.</p>
              <p><strong>8.3.</strong> Módosításokat írásban vagy email útján kell jelezni.</p>
              <p><strong>8.4.</strong> Jelentős módosítások esetén új árajánlat készül.</p>
            </div>
          </div>

          {/* 9. Adatvédelem */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              9. Adatvédelem
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>9.1.</strong> A Szolgáltató a GDPR rendelkezései szerint kezeli a személyes adatokat.</p>
              <p><strong>9.2.</strong> Az adatokat kizárólag a szolgáltatás teljesítése céljából használjuk fel.</p>
              <p><strong>9.3.</strong> A Megrendelő adatait nem adjuk át harmadik félnek.</p>
              <p><strong>9.4.</strong> Az adatokat a jogszabályi előírásoknak megfelelően tároljuk és töröljük.</p>
            </div>
          </div>

          {/* 10. Vis maior */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              10. Vis maior (elháríthatatlan külső ok)
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>10.1.</strong> Vis maior esetnek minősül: természeti katasztrófa, háború, járvány, hatósági intézkedés.</p>
              <p><strong>10.2.</strong> Vis maior esetén a teljesítési határidők automatikusan meghosszabbodnak.</p>
              <p><strong>10.3.</strong> Vis maior miatt keletkezett károkért a Szolgáltató nem vállal felelősséget.</p>
            </div>
          </div>

          {/* 11. Vitarendezés */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              11. Vitarendezés
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>11.1.</strong> A felek elsősorban békés megegyezéssel törekednek a viták rendezésére.</p>
              <p><strong>11.2.</strong> Sikertelen egyeztetés esetén a Szolnoki Járásbíróság illetékes.</p>
              <p><strong>11.3.</strong> A szerződésre a magyar jog az irányadó.</p>
              <p><strong>11.4.</strong> Fogyasztói viták esetén lehetőség van békéltető testülethez fordulni.</p>
            </div>
          </div>

          {/* 12. Különleges szolgáltatások */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              12. Különleges szolgáltatások
            </h2>
            <div className="space-y-6 text-gray-700">
              
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">12.1. Napelem rendszerek</h3>
                <ul className="ml-6 space-y-2">
                  <li>• Állami támogatás ügyintézésében segítségnyújtás</li>
                  <li>• 5 év garancia a telepített rendszerre</li>
                  <li>• 25 év teljesítménygarancia a napelemekre</li>
                  <li>• Éves karbantartási szerződés lehetősége</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">12.2. Rendezvények elektromos kiszolgálása</h3>
                <ul className="ml-6 space-y-2">
                  <li>• Eszközbérlés (villanyóraszekrények, kábelek)</li>
                  <li>• Teljes körű ügyintézés és engedélyeztetés</li>
                  <li>• Helyszíni szerelés és biztonságos kiépítés</li>
                  <li>• 24/7 ügyeleti szolgálat rendezvény alatt</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">12.3. Villamosbiztonsági felülvizsgálat</h3>
                <ul className="ml-6 space-y-2">
                  <li>• Érintésvédelmi mérések</li>
                  <li>• Szigetelési ellenőrzések</li>
                  <li>• Dokumentáció és jegyzőkönyv készítése</li>
                  <li>• Hatósági előírások szerinti elvégzés</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 13. Munkavédelem és biztonság */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              13. Munkavédelem és biztonság
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>13.1.</strong> A Szolgáltató vállalja a munkavédelmi előírások betartását.</p>
              <p><strong>13.2.</strong> Minden munkatárs rendelkezik érvényes szakképesítéssel.</p>
              <p><strong>13.3.</strong> A munkavégzés során megfelelő védőfelszerelést használunk.</p>
              <p><strong>13.4.</strong> Veszélyes munkák esetén külön biztonsági intézkedések alkalmazása.</p>
            </div>
          </div>

          {/* 14. Környezetvédelem */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              14. Környezetvédelem
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>14.1.</strong> A Szolgáltató elkötelezett a környezetvédelem iránt.</p>
              <p><strong>14.2.</strong> A hulladékok szakszerű elszállítása és újrahasznosítása.</p>
              <p><strong>14.3.</strong> Energiahatékony megoldások preferálása.</p>
              <p><strong>14.4.</strong> Környezetbarát technológiák alkalmazása.</p>
            </div>
          </div>

          {/* 15. Záró rendelkezések */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">
              15. Záró rendelkezések
            </h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>15.1.</strong> Jelen ÁSZF 2024. január 1-jétől hatályos.</p>
              <p><strong>15.2.</strong> A Szolgáltató fenntartja a jogot az ÁSZF módosítására.</p>
              <p><strong>15.3.</strong> Az ÁSZF módosításáról a Megrendelőket előzetesen tájékoztatjuk.</p>
              <p><strong>15.4.</strong> Jelen ÁSZF-ben nem szabályozott kérdésekben a Polgári Törvénykönyv rendelkezései az irányadóak.</p>
            </div>
          </div>

          {/* Hatálybalépés */}
          <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-red-600">
            <p className="text-gray-700 font-medium">
              <strong>Hatálybalépés:</strong> 2024. január 1.<br/>
              <strong>Utolsó módosítás:</strong> 2024. január 1.<br/>
              <strong>Verzió:</strong> 1.0
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">
            Kérjen Árajánlatot!
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl font-semibold mb-6">Elérhetőségeink</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Nagy Péter Villanyszerelő mester</div>
                    <a 
                      href="tel:+36703620652"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36703620652
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📞
                  </div>
                  <div>
                    <div className="font-medium">Tamasi Krisztán villamosbiztonsági felülvizsgáló</div>
                    <a 
                      href="tel:+36706049889"
                      className="text-red-400 hover:text-red-300 font-semibold transition-colors"
                    >
                      +36706049889
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    ✉️
                  </div>
                  <div>
                    <a 
                      href="mailto:kelectrokft@gmail.com"
                      className="hover:text-red-400 transition-colors"
                    >
                      kelectrokft@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white text-xl">
                    📍
                  </div>
                  <div>
                    <span>SZOLNOK és 100km-es körzete</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Gyors kapcsolatfelvétel</h3>
              <p className="text-gray-300 mb-4">
                Hívjon minket bizalommal! Ingyenes helyszíni felméréssel és 
                részletes árajánlattal várjuk megkeresését.
              </p>
              <div className="space-y-2">
                <p className="text-red-400 font-semibold">📞 Azonnali válasz</p>
                <p className="text-red-400 font-semibold">📋 Ingyenes felmérés</p>
                <p className="text-red-400 font-semibold">💰 Versenyképes árak</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ASZF;
